<template>

	<div  >
  <el-card :body-style="cardBodyStyle">
		<el-form :model="query" label-width="80px" inline center>
			<el-form-item label="操作人" class="no-show-error-message">
				<el-input v-model="query.addUser" size="small" placeholder="操作人" style="width :150px;"></el-input>
			</el-form-item>
			<el-form-item label="开始时间" class="no-show-error-message">
				<el-date-picker  size="small"  v-model="startTime" value-format="yyyy-MM-dd"  style="width :150px;"></el-date-picker>
			</el-form-item>
			<el-form-item label="结束时间" class="no-show-error-message">
				<el-date-picker  size="small"  v-model="endTime" value-format="yyyy-MM-dd"  style="width :150px;"></el-date-picker>
			</el-form-item>
			<el-form-item  class="no-show-error-message">
				<el-button type="primary"  size="small"  @click="search">查询</el-button>
			</el-form-item>
		</el-form>
  </el-card>
<el-card :body-style="cardBodyStyle">
		<el-table v-loading="loading" :data="tableData" border style="width: 99%">
			<el-table-column prop="id" label="Id" v-if="isShow" width="100" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="addUser.userDesc" label="操作人" width="120" align="center" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="addTime" label="操作时间" width="180" align="center" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="logData" label="日志内容" width="100" align="center" show-overflow-tooltip>
				<template slot-scope="scope" align="center">
					<el-button type="primary" size="mini" plain  @click="show(scope.row)">明细</el-button>
				</template>
			</el-table-column> 
			<el-table-column prop="logInfo" label="日志信息" width="160" align="center" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="logType" label="日志类型" width="130" align="center" show-overflow-tooltip>
			</el-table-column>
      <el-table-column prop="port" label="框架端口" width="130" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="className" label="类名" width="500" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="methodName" label="方法名" width="180" align="center" show-overflow-tooltip>
      </el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
		 :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
		</el-pagination>
  </el-card>
		<el-dialog :close-on-click-modal="false"   v-dialogDrag title="显示" :visible.sync="dialogVisible" width="500px">
			<el-input type="textarea" v-model="logData" autosize></el-input>
		</el-dialog>
	</div>
</template>

<script>
	import axios from '@/axios'
  import tools from '@/tools'
	import {
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				cardBodyStyle: tools.style.card,
				startTime: '',
				endTime: '',
				//表格初始化参数
				tableData: [],
				dialogVisible: false,
				logData: '',
				// 分页
				currentPage: 1,
				totalRows: 0,
				pageSizes: [10, 20, 30, 40],
				pageSize: 10,
				//查询条件
				query: {
					addUser: '',
					addTime: '',
				},
				isShow: false,
				loading: true,
			}
		},
		//界面渲染完毕调用   初始化表格参数
		mounted() {
      	this.getDate()
			this.getTableData()

		},
		methods: {
			// 获取table数据
			getTableData() {
				//console.log("获取table数据getTableData")
				var url = 'framework/SysLog/query.do'
				//var start = (this.currentPage - 1) * this.pageSize
				//var end = this.pageSize
				var param = {
					page: this.currentPage,
					rows: this.pageSize,
					addUser: this.query.addUser,
					addTime: this.query.addTime,
					startTime: this.startTime,
					endTime: this.endTime,
				}
				axios.get(url, param).then(response => {
					//console.log(response.data.data.list)
					if (response.data.code == '0') {
						this.tableData = response.data.data.list
						this.totalRows = response.data.data.total
					} else {
						this.$message({
							type: 'error',
							message: '操作失败!' + response.data.msg
						});
					}
					this.loading = false
				});
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getTableData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData()
			},
			search() {
				this.getTableData()
			},
			show(row) {
				this.dialogVisible = true
				this.logData = row.logData
			},
			getDate() {
				let date = new Date()
				let year = date.getFullYear().toString()
				let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
				let da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
				this.endTime = year + '-' + month + '-' + da
				this.startTime = year + '-' + month + '-01'
				this.getTableData()
			},
		}
	}
</script>
<style>
	/* 	.el-input {
		width: 300px;
	} */
</style>



// WEBPACK FOOTER //
// src/view/system/log.vue